import {
  required,
  SelectInput,
  usePermissions,
  useRecordContext,
} from "react-admin";

import { UserRole } from "@/constants";

import { type UserRecord } from "./types";

export const UserActiveInput = () => {
  const record = useRecordContext<UserRecord>();
  const isEditedUserAdmin = record?.roles?.includes(UserRole.ADMIN);

  const { permissions } = usePermissions<UserRole[]>();
  const isAdmin = permissions?.includes(UserRole.ADMIN);

  if (isEditedUserAdmin || !isAdmin) return null;

  return (
    <SelectInput
      source="active"
      validate={required()}
      choices={[
        { id: true, name: "Активен" },
        { id: false, name: "Неактивен" },
      ]}
    />
  );
};
